export default __webpack_public_path__ + "static/media/columnDefault.968527aa.svg";